import { ContainerModule } from 'inversify';
import AdapterFactory from '@framework/di/Providers/Rpc/AdapterFactory';
import { Dispatcher } from '../Dispatcher';
import DITypes from './types';
import type { IDispatcher, IAdapterFactory } from './interfaces';

export const DispatcherModule = new ContainerModule(({ bind }) => {
  bind<IAdapterFactory>(DITypes.AdapterFactory).to(AdapterFactory).inSingletonScope();

  bind<IDispatcher>(DITypes.JsonRpcDispatcher).to(Dispatcher).inSingletonScope();
});
